import React from 'react';
import { Button } from '../common/Button';
import { FolderPlus, FolderOpen } from 'lucide-react';
import { useAppStore } from '../../store';
import { useProjectOpen } from '../../hooks/useProjectOpen';

export const ActionButtons: React.FC = () => {
  const { openNewProjectDialog } = useAppStore();
  const { openProject } = useProjectOpen();

  const handleOpenProject = async () => {
    try {
      await openProject();
    } catch (error) {
      console.error('Failed to open project:', error);
    }
  };

  return (
    <div className="flex items-center justify-center gap-4">
      <Button
        variant="primary"
        size="lg"
        icon={<FolderPlus size={20} />}
        onClick={openNewProjectDialog}
      >
        New Project
      </Button>
      <Button
        variant="secondary"
        size="lg"
        icon={<FolderOpen size={20} />}
        onClick={handleOpenProject}
      >
        Open Project
      </Button>
    </div>
  );
};
